<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      @click="toggleDialogVisible(true)"
      >添加消息</el-button
    >
    <el-dialog
      title="添加消息"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <el-form :model="form" ref="form" label-width="140px" class="notice-form">
        <!-- <el-form-item
          label="类型："
          prop="type"
          :rules="[
            { required: true, message: '类型不能为空'}
          ]"
        >
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in noticeTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="标题：" prop="title">
          <div v-for="lang in languageList" :key="lang.value">
            （{{ lang.label }}标题）
            <el-input
              type="text"
              v-model="form.title[lang.value]"
              auto-complete="off"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item prop="content" label="内容：">
          <div
            v-if="form.type === 2"
            v-for="lang in languageList"
            :key="lang.value"
          >
            （{{ lang.label }}内容）
            <editor v-model="form.content[lang.value]" class="editor"></editor>
          </div>
          <div
            v-if="form.type === 1"
            v-for="lang in languageList"
            :key="lang.value"
          >
            （{{ lang.label }}内容）
            <upload
              :data="{ language: lang.value }"
              v-model="form.content[lang.value]"
            ></upload>
          </div>
        </el-form-item>
        <el-form-item prop="url" label="跳转链接：">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="save('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from 'components/editor';
import Upload from 'components/upload';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'CreateNotice',
  components: {
    Editor,
    Upload
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        type: 1,
        title: {},
        content: {}
      }
    };
  },
  computed: {
    ...mapState('notice', ['languageList', 'noticeTypes'])
  },
  methods: {
    ...mapActions('notice', ['create']),
    toggleDialogVisible(visible) {
      this.dialogVisible = visible;
    },
    closeDialog() {
      this.$refs['form'].resetFields();
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.create({
            ...this.form,
            title: JSON.stringify(this.form.title),
            content: JSON.stringify(this.form.content)
          }).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.toggleDialogVisible(false);
            this.$emit('refresh');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.notice-form {
  margin-right: 100px;
}
.editor {
  height: 500px;
}
</style>
